import { UserProfile } from '@/modules/auth/types';
import { META_ONBOARDING_COMPLETED } from '@/modules/onboarding/const';

// value of META_ONBOARDING_COMPLETED must be true not truthy
export const onBoardCompleted = (user: UserProfile) =>
  (user?.meta as any)?.[META_ONBOARDING_COMPLETED] === true;
